var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExtensivoR3ClinicaMedica(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 498.509,
    height: 138.337,
    viewBox: "0 0 498.509 138.337",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ae3bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c21fd"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ret\\xE2ngulo_2368",
    x: 390.667,
    y: 79.61,
    width: 107.841,
    height: 58.001,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ret\\xE2ngulo_2370",
    x: 390.748,
    y: 0.468,
    width: 107.76,
    height: 105.381,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_2438",
    x: 0,
    y: 0.767,
    width: 67.503,
    height: 79.845,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_2439",
    x: 38.224,
    y: 0.767,
    width: 80.301,
    height: 79.845,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_2440",
    x: 87.494,
    y: 0.767,
    width: 65.166,
    height: 79.845,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_2441",
    x: 127.005,
    y: 0.767,
    width: 67.502,
    height: 79.845,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_2442",
    x: 170.57,
    y: 0.767,
    width: 72.615,
    height: 79.845,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_2443",
    x: 216.726,
    y: 0,
    width: 74.733,
    height: 81.379,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ret\\xE2ngulo_2371",
    x: 267.303,
    y: 0.767,
    width: 45.3,
    height: 79.845,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_2444",
    x: 287.195,
    y: 0.767,
    width: 77.234,
    height: 79.845,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_2445",
    x: 335.442,
    y: 0.001,
    width: 77.436,
    height: 81.379,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_2446",
    x: 0.077,
    y: 61.683,
    width: 68.98,
    height: 75.947,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_2447",
    x: 43.256,
    y: 61.683,
    width: 73.507,
    height: 75.947,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-13"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_2448",
    x: 90.997,
    y: 61.683,
    width: 70.898,
    height: 75.947,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-14"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_2449",
    x: 138.559,
    y: 61.683,
    width: 70.865,
    height: 75.947,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-15"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-15"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_2450",
    x: 181.847,
    y: 61.683,
    width: 91.095,
    height: 75.947,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-16"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-16"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_2451",
    x: 244.255,
    y: 60.977,
    width: 73.726,
    height: 77.361,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-17"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-17"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_2452",
    x: 293.939,
    y: 61.683,
    width: 70.898,
    height: 75.947,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-18"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-18"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_2453",
    x: 341.502,
    y: 61.683,
    width: 71.437,
    height: 75.947,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-19"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-19"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "extensivoR3ClinicaMedica",
    transform: "translate(428 -712)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -428, 712)",
    filter: "url(#Ret\\xE2ngulo_2368)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2368-2",
    "data-name": "Ret\\xE2ngulo 2368",
    width: 77.841,
    height: 28.001,
    transform: "translate(405.67 94.61)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -428, 712)",
    filter: "url(#Ret\\xE2ngulo_2370)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2370-2",
    "data-name": "Ret\\xE2ngulo 2370",
    width: 77.76,
    height: 75.381,
    transform: "translate(405.75 15.47)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -428, 712)",
    filter: "url(#Caminho_2438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2438-2",
    "data-name": "Caminho 2438",
    d: "M0,1.147V50.992H37.5v-11.9H15.009V30.945H33.193V19.88H15.009V12.65H37.5V1.147Z",
    transform: "translate(15 14.62)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -428, 712)",
    filter: "url(#Caminho_2439)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2439-2",
    "data-name": "Caminho 2439",
    d: "M105.154,1.147,90.665,24.268l16.789,26.724h-17.8l-9.2-15.7-9.291,15.7h-14L73.209,25.254,57.811,1.147H75.656L83.39,14.561,91.417,1.147Z",
    transform: "translate(-3.93 14.62)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -428, 712)",
    filter: "url(#Caminho_2440)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2440-2",
    "data-name": "Caminho 2440",
    d: "M155.653,13.088v37.9h-14.5v-37.9H130.822V1.147h35.166V13.088Z",
    transform: "translate(-28.33 14.62)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -428, 712)",
    filter: "url(#Caminho_2441)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2441-2",
    "data-name": "Caminho 2441",
    d: "M227.4,39.088v11.9H189.9V1.148h37.5v11.5H204.907v7.23h18.185V30.945H204.907v8.143Z",
    transform: "translate(-47.89 14.62)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -428, 712)",
    filter: "url(#Caminho_2442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2442-2",
    "data-name": "Caminho 2442",
    d: "M297.652,50.992H285.2L271.548,28.969a83.928,83.928,0,0,1-5.3-10.294,34.7,34.7,0,0,1,1.205,8.179V50.992H255.037V1.147H269.5L281.111,19.4a70.418,70.418,0,0,1,5.257,9.569A72.455,72.455,0,0,1,285.2,15.9V1.147h12.452Z",
    transform: "translate(-69.47 14.62)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -428, 712)",
    filter: "url(#Caminho_2443)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2443-2",
    "data-name": "Caminho 2443",
    d: "M324.051,36.188l14.2-2.556q1.789,6.025,9.2,6.025,5.768,0,5.769-3.067a2.845,2.845,0,0,0-1.333-2.5,14.311,14.311,0,0,0-4.766-1.587q-13.111-2.513-16.835-6.567A13.639,13.639,0,0,1,326.57,16.4a14.922,14.922,0,0,1,5.35-11.725Q337.27,0,347.312,0q15.228,0,20.121,12.233l-12.671,3.834q-1.972-5-8-5-5,0-5,3.1a2.455,2.455,0,0,0,1.132,2.155,13.849,13.849,0,0,0,4.383,1.458,92.712,92.712,0,0,1,12.71,3.348,13.691,13.691,0,0,1,6.279,4.982,13.927,13.927,0,0,1,2.518,8.313,14.729,14.729,0,0,1-6.135,12.261q-6.135,4.7-16.1,4.695-18.222,0-22.495-15.191",
    transform: "translate(-92.32 15)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -428, 712)",
    filter: "url(#Ret\\xE2ngulo_2371)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2371-2",
    "data-name": "Ret\\xE2ngulo 2371",
    width: 15.3,
    height: 49.845,
    transform: "translate(282.3 15.77)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -428, 712)",
    filter: "url(#Caminho_2444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2444-2",
    "data-name": "Caminho 2444",
    d: "M476.65,1.147,461.183,50.992H445.59L429.416,1.147H445.54l7.888,27.168q.807,2.411,1.431,4.747l9.211-31.915Z",
    transform: "translate(-127.22 14.62)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -428, 712)",
    filter: "url(#Caminho_2445)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2445-2",
    "data-name": "Caminho 2445",
    d: "M525.328,51.38q-10.517,0-17.144-6.975t-6.628-18.66q0-11.175,6.336-18.459T525.474,0q10.407,0,16.962,6.865T548.992,25.2q0,11.868-6.61,19.025T525.328,51.38m-.072-11.32a5.786,5.786,0,0,0,5.568-3.378q1.7-3.377,1.7-12.361,0-13-6.975-13-7.522,0-7.523,14.825,0,13.913,7.231,13.913",
    transform: "translate(-151.11 15)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -428, 712)",
    filter: "url(#Caminho_2446)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2446-2",
    "data-name": "Caminho 2446",
    d: "M39.1,92.229v45.947h-14.1V120.3H14.22v17.874H.115V92.229h14.1v16.9H24.992v-16.9Z",
    transform: "translate(14.96 -15.55)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -428, 712)",
    filter: "url(#Caminho_2447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2447-2",
    "data-name": "Caminho 2447",
    d: "M93.791,138.176l-2.6-9.055H78.886l-2.759,9.055H64.677L78.862,92.229H93.773l14.411,45.947ZM81.283,119.091h7.434L85,105.762Z",
    transform: "translate(-6.42 -15.55)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -428, 712)",
    filter: "url(#Caminho_2448)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2448-2",
    "data-name": "Caminho 2448",
    d: "M176.957,138.176H161.321L154.61,120.6h-4.448v17.571h-14.1V92.229h24q7.943,0,12.337,3.719a12.227,12.227,0,0,1,4.393,9.813,14.749,14.749,0,0,1-1.616,7.018q-1.615,3.047-6.53,5.368Zm-26.794-27.4h6.025a7.414,7.414,0,0,0,4.275-1.111,3.707,3.707,0,0,0,1.616-3.265q0-4.409-5.419-4.409h-6.5Z",
    transform: "translate(-30.06 -15.55)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -428, 712)",
    filter: "url(#Caminho_2449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2449-2",
    "data-name": "Caminho 2449",
    d: "M207.175,138.176V92.229h17.773q11.579,0,17.335,6.867a24,24,0,0,1,5.756,15.888q0,10.3-6.177,16.746t-16.039,6.447Zm14.1-10.57h3.669a7.071,7.071,0,0,0,5.908-3.4q2.407-3.4,2.407-9.257a16.773,16.773,0,0,0-2.137-8.651,6.78,6.78,0,0,0-6.177-3.636h-3.669Z",
    transform: "translate(-53.62 -15.55)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -428, 712)",
    filter: "url(#Caminho_2450)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2450-2",
    "data-name": "Caminho 2450",
    d: "M332.994,92.229l-12.187,45.947H308.959l-6.428-25.347-6.069,25.347H284.108L271.9,92.229h13.272l6.427,26.445,6.27-26.445h11.073l6.82,26.5,6.437-26.5Z",
    transform: "translate(-75.05 -15.55)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -428, 712)",
    filter: "url(#Caminho_2451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2451-2",
    "data-name": "Caminho 2451",
    d: "M387.125,138.534q-9.695,0-15.8-6.429t-6.11-17.2q0-10.3,5.84-17.016t16.208-6.715q9.594,0,15.635,6.328t6.043,16.9q0,10.94-6.093,17.537a20.425,20.425,0,0,1-15.72,6.6m-.068-10.435a5.331,5.331,0,0,0,5.133-3.114q1.566-3.113,1.566-11.394,0-11.983-6.429-11.984-6.935,0-6.934,13.666,0,12.825,6.665,12.825",
    transform: "translate(-105.96 -15.2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -428, 712)",
    filter: "url(#Caminho_2452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2452-2",
    "data-name": "Caminho 2452",
    d: "M480.4,138.176H464.763L458.051,120.6H453.6v17.571H439.5V92.229h24q7.943,0,12.337,3.719a12.227,12.227,0,0,1,4.393,9.813,14.749,14.749,0,0,1-1.616,7.018q-1.615,3.047-6.53,5.368Zm-26.794-27.4h6.025a7.414,7.414,0,0,0,4.275-1.111,3.707,3.707,0,0,0,1.616-3.265q0-4.409-5.419-4.409h-6.5Z",
    transform: "translate(-130.56 -15.55)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -428, 712)",
    filter: "url(#Caminho_2453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2453-2",
    "data-name": "Caminho 2453",
    d: "M552.053,138.177H536.621l-7.943-17.363-4.765,6.76v10.6h-13.3V92.229h13.3v19l12.671-19H549.26l-11.6,16.816Z",
    transform: "translate(-154.11 -15.55)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2454",
    "data-name": "Caminho 2454",
    d: "M600.539,141.1q0,4.7-4.648,4.716t-4.635-4.716V127.4q0-4.705,4.635-4.705t4.648,4.705v5.48h-3.232V127.4q0-1.508-1.4-1.519h-.022q-1.394,0-1.393,1.519v13.7q0,1.52,1.4,1.519t1.416-1.519v-3.642h3.232Z",
    transform: "translate(-608.822 686.363)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2455",
    "data-name": "Caminho 2455",
    d: "M609.063,145.631v-22.4h3.232v19.217h5.149v3.186Z",
    transform: "translate(-614.72 686.187)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2372",
    "data-name": "Ret\\xE2ngulo 2372",
    width: 3.232,
    height: 22.402,
    transform: "translate(4.723 809.415)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2456",
    "data-name": "Caminho 2456",
    d: "M633.937,123.228H636.6l3.505,6.166v-6.166h3.117v22.4H640.1V135.217l-3.048-5.481V145.63h-3.117Z",
    transform: "translate(-622.958 686.187)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2373",
    "data-name": "Ret\\xE2ngulo 2373",
    width: 3.232,
    height: 22.402,
    transform: "translate(23.288 809.415)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2457",
    "data-name": "Caminho 2457",
    d: "M670.638,141.1q0,4.7-4.647,4.716t-4.636-4.716V127.4q0-4.705,4.636-4.705t4.647,4.705v5.48h-3.232V127.4q0-1.508-1.4-1.519h-.022q-1.394,0-1.393,1.519v13.7q0,1.52,1.4,1.519t1.416-1.519v-3.642h3.232Z",
    transform: "translate(-632.039 686.363)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2458",
    "data-name": "Caminho 2458",
    d: "M681.462,141.063l-.583,4.567h-3.254l3.334-22.4h4.43l3.323,22.4h-3.266l-.582-4.567Zm3.014-3.083-1.313-10.413L681.85,137.98Z",
    transform: "translate(-637.427 686.187)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2459",
    "data-name": "Caminho 2459",
    d: "M616.4,54.59l9.528,18.567h-10.08l-8.194-16.908h-1.268V73.156h-9.2V9.36h13.4q12.258.033,12.258,13.429v20.03q0,8.455-6.439,11.771M606.383,18.4v29.07H608.5a8.868,8.868,0,0,0,2.634-.26,3.949,3.949,0,0,0,2.5-4.065V22.757q0-4.357-4-4.357Z",
    transform: "translate(-610.784 723.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2460",
    "data-name": "Caminho 2460",
    d: "M665.172,21.25q0-4.292-4-4.324h-.065q-3.968,0-3.967,4.324V29.8h-9.2V21.25q0-13.4,13.2-13.4,13.234,0,13.234,13.4v9.137q0,8.226-5.69,10.828,5.689,2.6,5.69,10.827v8.227q0,13.4-13.234,13.4-13.2,0-13.2-13.4V51.717h9.2v8.552q0,4.325,3.967,4.324h.065q4-.032,4-4.324V52.042q0-6.4-5.821-6.405h-1.723V36.565h2.438q5.1,0,5.1-6.243Z",
    transform: "translate(-627.595 724.399)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtensivoR3ClinicaMedica);
export default __webpack_public_path__ + "static/media/extensivoR3ClinicaMedica.79257fc11990ee2778296d21f3794804.svg";
export { ForwardRef as ReactComponent };